import actionTypes from '../actionTypes';


const initMenu = (menu) => {
  return {
    type: actionTypes.navigation.INIT_MENU,
    menu: menu
  }
}

const errored = (errorMessage) => {
  return {
    type: actionTypes.navigation.ERRORED,
    error: errorMessage
  };
}

const getMenu = () => {
  return {
    type: actionTypes.navigation.GET_MENU
  };
}

const setTitle = (title) => {
  return {
    type: actionTypes.navigation.SET_TITLE,
    title: title
  };
}

const refreshTitle = () => {
  return {
    type: actionTypes.navigation.REFRESH_TITLE
  };
}

export const navigationActions = {
  initMenu: initMenu,
  errored: errored,
  getMenu: getMenu,
  setTitle: setTitle,
  refreshTitle: refreshTitle
}